module.exports = __webpack_public_path__ + "static/media/impersonator_thumbnail.30e50934.png";